import { ENTITY_TYPES } from '@sales-center/common'

import { useScheduleServiceAutoClosable } from '@user/query/useMissingAutoCloseRequiredFields'

import { useSchedulingWizard } from '../wizardContext'
import {
  resolveLeadScheduleAutoClose,
  type LeadAutoCloseGate,
} from './leadAutoCloseGate'

export type LeadScheduleAutoClose = LeadAutoCloseGate & {
  isLoading: boolean
}

export function useLeadScheduleAutoClose(): LeadScheduleAutoClose {
  const [{ entityId, entityType, mode }] = useSchedulingWizard()

  const enabled = mode === 'service' && entityType === ENTITY_TYPES.Lead

  const { data, isLoading } = useScheduleServiceAutoClosable(entityId, enabled)

  return {
    isLoading: enabled && isLoading,
    ...resolveLeadScheduleAutoClose(enabled ? data : undefined),
  }
}
